import * as React from 'react';
import { SVGProps } from 'react';

const SvgQuotes = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.75 21C7.96997 21 6.22991 20.4722 4.74987 19.4832C3.26982 18.4943 2.11627 17.0887 1.43508 15.4442C0.753894 13.7996 0.575664 11.99 0.922931 10.2442C1.2702 8.49836 2.12737 6.89472 3.38604 5.63604C4.64471 4.37737 6.24836 3.5202 7.99419 3.17294C9.74002 2.82567 11.5496 3.0039 13.1942 3.68509C14.8387 4.36628 16.2443 5.51983 17.2332 6.99987C18.2222 8.47991 18.75 10.22 18.75 12V16.65L21.45 13.95L22.5 15L18 19.5L13.5 15L14.55 13.95L17.25 16.65V12C17.25 10.5166 16.8101 9.0666 15.986 7.83323C15.1619 6.59986 13.9906 5.63856 12.6201 5.07091C11.2497 4.50325 9.74168 4.35473 8.28682 4.64411C6.83196 4.9335 5.49559 5.64781 4.4467 6.6967C3.3978 7.7456 2.6835 9.08197 2.39411 10.5368C2.10472 11.9917 2.25324 13.4997 2.8209 14.8701C3.38856 16.2406 4.34985 17.4119 5.58322 18.236C6.81659 19.0601 8.26664 19.5 9.75 19.5V21Z'
      fill='black'
    />
  </svg>
);

export default SvgQuotes;
